export default "__VITE_ASSET__72N2nm86__"